// removed by extract-text-webpack-plugin
module.exports = {"Articles":"_2xR_rJQ60uv9ElVGBLdJKC","Article":"_1b9digx_1TwyVSc9hvKEW4","IntroBlock":"_1l_JvK9oOok_Tk5-dEpUSJ EKGo-NCx1zPe_WT3YYEnX"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/FAQArticles/styles.css
// module id = 675
// module chunks = 0